import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "q-ml-sm text-body2" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { useLocalUserSettingsStore } from "src/stores/localUserSettingsStore"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { WorkOrderCardData } from "src/util/types/dataModels/workOrder"
import { PropType, ref } from "vue"
import { useI18n } from "vue-i18n"
import SfxCardWorkOrderCondensed from "../card/SfxCardWorkOrderCondensed.vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogRemoveIssueFromWorkOrder',
  props: {
  workOrder: { type: Object as PropType<WorkOrderCardData>, required: true },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const dontAskAgain = ref(false)

//endregion

//region Functions

function onConfirm() {
  if (dontAskAgain.value) {
    useLocalUserSettingsStore().skipConfirmRemoveIssueFromWorkOrder = true
  }
  onDialogOK()
}
//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "q-dialog-plugin q-pa-sm",
        style: {"width":"576px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title text-h3 q-pb-none" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogRemoveEntityFromWorkOrder.title_issue")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-py-none q-mt-md" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "text-body1",
                innerHTML: _unref(t)('sfxDialogRemoveEntityFromWorkOrder.content_issue')
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-none q-mt-lg" }, {
            default: _withCtx(() => [
              _createVNode(SfxCardWorkOrderCondensed, {
                "work-order": props.workOrder,
                clickable: false
              }, null, 8, ["work-order"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "row items-center q-mt-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_checkbox, {
                size: "56px",
                class: "sfx-checkbox",
                "checked-icon": _unref(Icons).ACCEPT,
                modelValue: dontAskAgain.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dontAskAgain).value = $event))
              }, null, 8, ["checked-icon", "modelValue"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("sfxDialogRemoveEntityFromWorkOrder.checkbox_label")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(t)('sfxButtons.btn_cancel'),
                class: "col"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: onConfirm,
                label: _unref(t)('sfxButtons.btn_confirm'),
                class: "col"
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})